/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WorkspaceRouteImport } from './routes/workspace'
import { Route as ManagementRouteImport } from './routes/management'
import { Route as publicPublicRouteImport } from './routes/(public)/_public'
import { Route as authVerifyEmailRouteImport } from './routes/(auth)/verify-email'
import { Route as authSelfServeSignupRouteImport } from './routes/(auth)/self-serve-signup'
import { Route as authResetPasswordRouteImport } from './routes/(auth)/reset-password'
import { Route as authRegisterRouteImport } from './routes/(auth)/register'
import { Route as authLoginRouteImport } from './routes/(auth)/login'
import { Route as authForgotPasswordRouteImport } from './routes/(auth)/forgot-password'
import { Route as authAcceptInviteRouteImport } from './routes/(auth)/accept-invite'
import { Route as appOnboardingRouteImport } from './routes/(app)/onboarding'
import { Route as appDashboardRouteImport } from './routes/(app)/dashboard'
import { Route as publicPublicIndexRouteImport } from './routes/(public)/_public/index'
import { Route as appDashboardIndexRouteImport } from './routes/(app)/dashboard/index'
import { Route as publicPublicProductsRouteImport } from './routes/(public)/_public/products'
import { Route as publicPublicFeaturesRouteImport } from './routes/(public)/_public/features'
import { Route as publicPublicDocsRouteImport } from './routes/(public)/_public/docs'
import { Route as authSelfServeSignupVerifyRouteImport } from './routes/(auth)/self-serve-signup/verify'
import { Route as authMagicLinkVerifyRouteImport } from './routes/(auth)/magic-link/verify'
import { Route as appDashboardVerificationsRouteImport } from './routes/(app)/dashboard/verifications'
import { Route as appDashboardTenantsRouteImport } from './routes/(app)/dashboard/tenants'
import { Route as appDashboardTeamRouteImport } from './routes/(app)/dashboard/team'
import { Route as appDashboardTaxpulseRouteImport } from './routes/(app)/dashboard/taxpulse'
import { Route as appDashboardTaxReadinessRouteImport } from './routes/(app)/dashboard/tax-readiness'
import { Route as appDashboardSuppliersRouteImport } from './routes/(app)/dashboard/suppliers'
import { Route as appDashboardStatusRouteImport } from './routes/(app)/dashboard/status'
import { Route as appDashboardSettingsRouteImport } from './routes/(app)/dashboard/settings'
import { Route as appDashboardProductsRouteImport } from './routes/(app)/dashboard/products'
import { Route as appDashboardPlatformRouteImport } from './routes/(app)/dashboard/platform'
import { Route as appDashboardOutboxRouteImport } from './routes/(app)/dashboard/outbox'
import { Route as appDashboardOnboardingStatusRouteImport } from './routes/(app)/dashboard/onboarding-status'
import { Route as appDashboardOnboardingRecordsRouteImport } from './routes/(app)/dashboard/onboarding-records'
import { Route as appDashboardObligationsRouteImport } from './routes/(app)/dashboard/obligations'
import { Route as appDashboardMonitoringRouteImport } from './routes/(app)/dashboard/monitoring'
import { Route as appDashboardInvoiceRepositoryRouteImport } from './routes/(app)/dashboard/invoice-repository'
import { Route as appDashboardInvoiceQueueRouteImport } from './routes/(app)/dashboard/invoice-queue'
import { Route as appDashboardInvoiceIntelligenceRouteImport } from './routes/(app)/dashboard/invoice-intelligence'
import { Route as appDashboardInvoiceGateRouteImport } from './routes/(app)/dashboard/invoice-gate'
import { Route as appDashboardGatewayAuditRouteImport } from './routes/(app)/dashboard/gateway-audit'
import { Route as appDashboardEvidenceRouteImport } from './routes/(app)/dashboard/evidence'
import { Route as appDashboardEtimsActivationRouteImport } from './routes/(app)/dashboard/etims-activation'
import { Route as appDashboardDeveloperRouteImport } from './routes/(app)/dashboard/developer'
import { Route as appDashboardCustomsTradeRouteImport } from './routes/(app)/dashboard/customs-trade'
import { Route as appDashboardComplianceWorkspaceRouteImport } from './routes/(app)/dashboard/compliance-workspace'
import { Route as appDashboardComplianceCalendarRouteImport } from './routes/(app)/dashboard/compliance-calendar'
import { Route as appDashboardBulkDocsRouteImport } from './routes/(app)/dashboard/bulk-docs'
import { Route as appDashboardAuditRiskRouteImport } from './routes/(app)/dashboard/audit-risk'
import { Route as appDashboardAuditResponseRouteImport } from './routes/(app)/dashboard/audit-response'
import { Route as appDashboardAuditReadinessRouteImport } from './routes/(app)/dashboard/audit-readiness'
import { Route as appDashboardAccessGrantsRouteImport } from './routes/(app)/dashboard/access-grants'
import { Route as appDashboardTenantsIndexRouteImport } from './routes/(app)/dashboard/tenants/index'
import { Route as appDashboardSettingsIndexRouteImport } from './routes/(app)/dashboard/settings/index'
import { Route as appDashboardInvoiceGateIndexRouteImport } from './routes/(app)/dashboard/invoice-gate/index'
import { Route as appDashboardAuditResponseIndexRouteImport } from './routes/(app)/dashboard/audit-response/index'
import { Route as publicPublicToolsWhtRouteImport } from './routes/(public)/_public/tools/wht'
import { Route as publicPublicToolsVatRouteImport } from './routes/(public)/_public/tools/vat'
import { Route as publicPublicToolsSupplierPreviewRouteImport } from './routes/(public)/_public/tools/supplier-preview'
import { Route as publicPublicToolsPenaltyEstimatorRouteImport } from './routes/(public)/_public/tools/penalty-estimator'
import { Route as publicPublicToolsPayeRouteImport } from './routes/(public)/_public/tools/paye'
import { Route as publicPublicToolsInvoiceOcrRouteImport } from './routes/(public)/_public/tools/invoice-ocr'
import { Route as publicPublicToolsEtimsChecklistRouteImport } from './routes/(public)/_public/tools/etims-checklist'
import { Route as publicPublicToolsDeductibilityRouteImport } from './routes/(public)/_public/tools/deductibility'
import { Route as publicPublicToolsDeadlineCalendarRouteImport } from './routes/(public)/_public/tools/deadline-calendar'
import { Route as publicPublicToolsCountyPermitsRouteImport } from './routes/(public)/_public/tools/county-permits'
import { Route as publicPublicToolsAdvisorRouteImport } from './routes/(public)/_public/tools/advisor'
import { Route as publicPublicSolutionsProductIdRouteImport } from './routes/(public)/_public/solutions/$productId'
import { Route as appDashboardTenantsTenantPublicIdRouteImport } from './routes/(app)/dashboard/tenants/$tenantPublicId'
import { Route as appDashboardSuppliersSupplierIdRouteImport } from './routes/(app)/dashboard/suppliers/$supplierId'
import { Route as appDashboardSettingsUserProfileRouteImport } from './routes/(app)/dashboard/settings/user-profile'
import { Route as appDashboardSettingsChangePasswordRouteImport } from './routes/(app)/dashboard/settings/change-password'
import { Route as appDashboardSettingsBillingRouteImport } from './routes/(app)/dashboard/settings/billing'
import { Route as appDashboardObligationsTaxTypeRouteImport } from './routes/(app)/dashboard/obligations/$taxType'
import { Route as appDashboardInvoiceGateReviewRouteImport } from './routes/(app)/dashboard/invoice-gate/review'
import { Route as appDashboardInvoiceGateNewRouteImport } from './routes/(app)/dashboard/invoice-gate/new'
import { Route as appDashboardInvoiceGateBatchRouteImport } from './routes/(app)/dashboard/invoice-gate/batch'
import { Route as appDashboardInvoiceGateAssessmentIdRouteImport } from './routes/(app)/dashboard/invoice-gate/$assessmentId'
import { Route as appDashboardInvoiceExceptionDocumentIdRouteImport } from './routes/(app)/dashboard/invoice-exception/$documentId'
import { Route as appDashboardGatewayEndpointsRouteImport } from './routes/(app)/dashboard/gateway/endpoints'
import { Route as appDashboardGatewayCredentialsRouteImport } from './routes/(app)/dashboard/gateway/credentials'
import { Route as appDashboardBulkDocsReviewQueueRouteImport } from './routes/(app)/dashboard/bulk-docs/review-queue'
import { Route as appDashboardAuditResponseCaseIdRouteImport } from './routes/(app)/dashboard/audit-response/$caseId'
import { Route as appDashboardAdvisorClientsRouteImport } from './routes/(app)/dashboard/advisor/clients'

const WorkspaceRoute = WorkspaceRouteImport.update({
  id: '/workspace',
  path: '/workspace',
  getParentRoute: () => rootRouteImport,
} as any)
const ManagementRoute = ManagementRouteImport.update({
  id: '/management',
  path: '/management',
  getParentRoute: () => rootRouteImport,
} as any)
const publicPublicRoute = publicPublicRouteImport.update({
  id: '/(public)/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const authVerifyEmailRoute = authVerifyEmailRouteImport.update({
  id: '/(auth)/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const authSelfServeSignupRoute = authSelfServeSignupRouteImport.update({
  id: '/(auth)/self-serve-signup',
  path: '/self-serve-signup',
  getParentRoute: () => rootRouteImport,
} as any)
const authResetPasswordRoute = authResetPasswordRouteImport.update({
  id: '/(auth)/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const authRegisterRoute = authRegisterRouteImport.update({
  id: '/(auth)/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const authLoginRoute = authLoginRouteImport.update({
  id: '/(auth)/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const authForgotPasswordRoute = authForgotPasswordRouteImport.update({
  id: '/(auth)/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const authAcceptInviteRoute = authAcceptInviteRouteImport.update({
  id: '/(auth)/accept-invite',
  path: '/accept-invite',
  getParentRoute: () => rootRouteImport,
} as any)
const appOnboardingRoute = appOnboardingRouteImport.update({
  id: '/(app)/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const appDashboardRoute = appDashboardRouteImport.update({
  id: '/(app)/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const publicPublicIndexRoute = publicPublicIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => publicPublicRoute,
} as any)
const appDashboardIndexRoute = appDashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appDashboardRoute,
} as any)
const publicPublicProductsRoute = publicPublicProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => publicPublicRoute,
} as any)
const publicPublicFeaturesRoute = publicPublicFeaturesRouteImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => publicPublicRoute,
} as any)
const publicPublicDocsRoute = publicPublicDocsRouteImport.update({
  id: '/docs',
  path: '/docs',
  getParentRoute: () => publicPublicRoute,
} as any)
const authSelfServeSignupVerifyRoute =
  authSelfServeSignupVerifyRouteImport.update({
    id: '/verify',
    path: '/verify',
    getParentRoute: () => authSelfServeSignupRoute,
  } as any)
const authMagicLinkVerifyRoute = authMagicLinkVerifyRouteImport.update({
  id: '/(auth)/magic-link/verify',
  path: '/magic-link/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const appDashboardVerificationsRoute =
  appDashboardVerificationsRouteImport.update({
    id: '/verifications',
    path: '/verifications',
    getParentRoute: () => appDashboardRoute,
  } as any)
const appDashboardTenantsRoute = appDashboardTenantsRouteImport.update({
  id: '/tenants',
  path: '/tenants',
  getParentRoute: () => appDashboardRoute,
} as any)
const appDashboardTeamRoute = appDashboardTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => appDashboardRoute,
} as any)
const appDashboardTaxpulseRoute = appDashboardTaxpulseRouteImport.update({
  id: '/taxpulse',
  path: '/taxpulse',
  getParentRoute: () => appDashboardRoute,
} as any)
const appDashboardTaxReadinessRoute =
  appDashboardTaxReadinessRouteImport.update({
    id: '/tax-readiness',
    path: '/tax-readiness',
    getParentRoute: () => appDashboardRoute,
  } as any)
const appDashboardSuppliersRoute = appDashboardSuppliersRouteImport.update({
  id: '/suppliers',
  path: '/suppliers',
  getParentRoute: () => appDashboardRoute,
} as any)
const appDashboardStatusRoute = appDashboardStatusRouteImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => appDashboardRoute,
} as any)
const appDashboardSettingsRoute = appDashboardSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => appDashboardRoute,
} as any)
const appDashboardProductsRoute = appDashboardProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => appDashboardRoute,
} as any)
const appDashboardPlatformRoute = appDashboardPlatformRouteImport.update({
  id: '/platform',
  path: '/platform',
  getParentRoute: () => appDashboardRoute,
} as any)
const appDashboardOutboxRoute = appDashboardOutboxRouteImport.update({
  id: '/outbox',
  path: '/outbox',
  getParentRoute: () => appDashboardRoute,
} as any)
const appDashboardOnboardingStatusRoute =
  appDashboardOnboardingStatusRouteImport.update({
    id: '/onboarding-status',
    path: '/onboarding-status',
    getParentRoute: () => appDashboardRoute,
  } as any)
const appDashboardOnboardingRecordsRoute =
  appDashboardOnboardingRecordsRouteImport.update({
    id: '/onboarding-records',
    path: '/onboarding-records',
    getParentRoute: () => appDashboardRoute,
  } as any)
const appDashboardObligationsRoute = appDashboardObligationsRouteImport.update({
  id: '/obligations',
  path: '/obligations',
  getParentRoute: () => appDashboardRoute,
} as any)
const appDashboardMonitoringRoute = appDashboardMonitoringRouteImport.update({
  id: '/monitoring',
  path: '/monitoring',
  getParentRoute: () => appDashboardRoute,
} as any)
const appDashboardInvoiceRepositoryRoute =
  appDashboardInvoiceRepositoryRouteImport.update({
    id: '/invoice-repository',
    path: '/invoice-repository',
    getParentRoute: () => appDashboardRoute,
  } as any)
const appDashboardInvoiceQueueRoute =
  appDashboardInvoiceQueueRouteImport.update({
    id: '/invoice-queue',
    path: '/invoice-queue',
    getParentRoute: () => appDashboardRoute,
  } as any)
const appDashboardInvoiceIntelligenceRoute =
  appDashboardInvoiceIntelligenceRouteImport.update({
    id: '/invoice-intelligence',
    path: '/invoice-intelligence',
    getParentRoute: () => appDashboardRoute,
  } as any)
const appDashboardInvoiceGateRoute = appDashboardInvoiceGateRouteImport.update({
  id: '/invoice-gate',
  path: '/invoice-gate',
  getParentRoute: () => appDashboardRoute,
} as any)
const appDashboardGatewayAuditRoute =
  appDashboardGatewayAuditRouteImport.update({
    id: '/gateway-audit',
    path: '/gateway-audit',
    getParentRoute: () => appDashboardRoute,
  } as any)
const appDashboardEvidenceRoute = appDashboardEvidenceRouteImport.update({
  id: '/evidence',
  path: '/evidence',
  getParentRoute: () => appDashboardRoute,
} as any)
const appDashboardEtimsActivationRoute =
  appDashboardEtimsActivationRouteImport.update({
    id: '/etims-activation',
    path: '/etims-activation',
    getParentRoute: () => appDashboardRoute,
  } as any)
const appDashboardDeveloperRoute = appDashboardDeveloperRouteImport.update({
  id: '/developer',
  path: '/developer',
  getParentRoute: () => appDashboardRoute,
} as any)
const appDashboardCustomsTradeRoute =
  appDashboardCustomsTradeRouteImport.update({
    id: '/customs-trade',
    path: '/customs-trade',
    getParentRoute: () => appDashboardRoute,
  } as any)
const appDashboardComplianceWorkspaceRoute =
  appDashboardComplianceWorkspaceRouteImport.update({
    id: '/compliance-workspace',
    path: '/compliance-workspace',
    getParentRoute: () => appDashboardRoute,
  } as any)
const appDashboardComplianceCalendarRoute =
  appDashboardComplianceCalendarRouteImport.update({
    id: '/compliance-calendar',
    path: '/compliance-calendar',
    getParentRoute: () => appDashboardRoute,
  } as any)
const appDashboardBulkDocsRoute = appDashboardBulkDocsRouteImport.update({
  id: '/bulk-docs',
  path: '/bulk-docs',
  getParentRoute: () => appDashboardRoute,
} as any)
const appDashboardAuditRiskRoute = appDashboardAuditRiskRouteImport.update({
  id: '/audit-risk',
  path: '/audit-risk',
  getParentRoute: () => appDashboardRoute,
} as any)
const appDashboardAuditResponseRoute =
  appDashboardAuditResponseRouteImport.update({
    id: '/audit-response',
    path: '/audit-response',
    getParentRoute: () => appDashboardRoute,
  } as any)
const appDashboardAuditReadinessRoute =
  appDashboardAuditReadinessRouteImport.update({
    id: '/audit-readiness',
    path: '/audit-readiness',
    getParentRoute: () => appDashboardRoute,
  } as any)
const appDashboardAccessGrantsRoute =
  appDashboardAccessGrantsRouteImport.update({
    id: '/access-grants',
    path: '/access-grants',
    getParentRoute: () => appDashboardRoute,
  } as any)
const appDashboardTenantsIndexRoute =
  appDashboardTenantsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appDashboardTenantsRoute,
  } as any)
const appDashboardSettingsIndexRoute =
  appDashboardSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appDashboardSettingsRoute,
  } as any)
const appDashboardInvoiceGateIndexRoute =
  appDashboardInvoiceGateIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appDashboardInvoiceGateRoute,
  } as any)
const appDashboardAuditResponseIndexRoute =
  appDashboardAuditResponseIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appDashboardAuditResponseRoute,
  } as any)
const publicPublicToolsWhtRoute = publicPublicToolsWhtRouteImport.update({
  id: '/tools/wht',
  path: '/tools/wht',
  getParentRoute: () => publicPublicRoute,
} as any)
const publicPublicToolsVatRoute = publicPublicToolsVatRouteImport.update({
  id: '/tools/vat',
  path: '/tools/vat',
  getParentRoute: () => publicPublicRoute,
} as any)
const publicPublicToolsSupplierPreviewRoute =
  publicPublicToolsSupplierPreviewRouteImport.update({
    id: '/tools/supplier-preview',
    path: '/tools/supplier-preview',
    getParentRoute: () => publicPublicRoute,
  } as any)
const publicPublicToolsPenaltyEstimatorRoute =
  publicPublicToolsPenaltyEstimatorRouteImport.update({
    id: '/tools/penalty-estimator',
    path: '/tools/penalty-estimator',
    getParentRoute: () => publicPublicRoute,
  } as any)
const publicPublicToolsPayeRoute = publicPublicToolsPayeRouteImport.update({
  id: '/tools/paye',
  path: '/tools/paye',
  getParentRoute: () => publicPublicRoute,
} as any)
const publicPublicToolsInvoiceOcrRoute =
  publicPublicToolsInvoiceOcrRouteImport.update({
    id: '/tools/invoice-ocr',
    path: '/tools/invoice-ocr',
    getParentRoute: () => publicPublicRoute,
  } as any)
const publicPublicToolsEtimsChecklistRoute =
  publicPublicToolsEtimsChecklistRouteImport.update({
    id: '/tools/etims-checklist',
    path: '/tools/etims-checklist',
    getParentRoute: () => publicPublicRoute,
  } as any)
const publicPublicToolsDeductibilityRoute =
  publicPublicToolsDeductibilityRouteImport.update({
    id: '/tools/deductibility',
    path: '/tools/deductibility',
    getParentRoute: () => publicPublicRoute,
  } as any)
const publicPublicToolsDeadlineCalendarRoute =
  publicPublicToolsDeadlineCalendarRouteImport.update({
    id: '/tools/deadline-calendar',
    path: '/tools/deadline-calendar',
    getParentRoute: () => publicPublicRoute,
  } as any)
const publicPublicToolsCountyPermitsRoute =
  publicPublicToolsCountyPermitsRouteImport.update({
    id: '/tools/county-permits',
    path: '/tools/county-permits',
    getParentRoute: () => publicPublicRoute,
  } as any)
const publicPublicToolsAdvisorRoute =
  publicPublicToolsAdvisorRouteImport.update({
    id: '/tools/advisor',
    path: '/tools/advisor',
    getParentRoute: () => publicPublicRoute,
  } as any)
const publicPublicSolutionsProductIdRoute =
  publicPublicSolutionsProductIdRouteImport.update({
    id: '/solutions/$productId',
    path: '/solutions/$productId',
    getParentRoute: () => publicPublicRoute,
  } as any)
const appDashboardTenantsTenantPublicIdRoute =
  appDashboardTenantsTenantPublicIdRouteImport.update({
    id: '/$tenantPublicId',
    path: '/$tenantPublicId',
    getParentRoute: () => appDashboardTenantsRoute,
  } as any)
const appDashboardSuppliersSupplierIdRoute =
  appDashboardSuppliersSupplierIdRouteImport.update({
    id: '/$supplierId',
    path: '/$supplierId',
    getParentRoute: () => appDashboardSuppliersRoute,
  } as any)
const appDashboardSettingsUserProfileRoute =
  appDashboardSettingsUserProfileRouteImport.update({
    id: '/user-profile',
    path: '/user-profile',
    getParentRoute: () => appDashboardSettingsRoute,
  } as any)
const appDashboardSettingsChangePasswordRoute =
  appDashboardSettingsChangePasswordRouteImport.update({
    id: '/change-password',
    path: '/change-password',
    getParentRoute: () => appDashboardSettingsRoute,
  } as any)
const appDashboardSettingsBillingRoute =
  appDashboardSettingsBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => appDashboardSettingsRoute,
  } as any)
const appDashboardObligationsTaxTypeRoute =
  appDashboardObligationsTaxTypeRouteImport.update({
    id: '/$taxType',
    path: '/$taxType',
    getParentRoute: () => appDashboardObligationsRoute,
  } as any)
const appDashboardInvoiceGateReviewRoute =
  appDashboardInvoiceGateReviewRouteImport.update({
    id: '/review',
    path: '/review',
    getParentRoute: () => appDashboardInvoiceGateRoute,
  } as any)
const appDashboardInvoiceGateNewRoute =
  appDashboardInvoiceGateNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => appDashboardInvoiceGateRoute,
  } as any)
const appDashboardInvoiceGateBatchRoute =
  appDashboardInvoiceGateBatchRouteImport.update({
    id: '/batch',
    path: '/batch',
    getParentRoute: () => appDashboardInvoiceGateRoute,
  } as any)
const appDashboardInvoiceGateAssessmentIdRoute =
  appDashboardInvoiceGateAssessmentIdRouteImport.update({
    id: '/$assessmentId',
    path: '/$assessmentId',
    getParentRoute: () => appDashboardInvoiceGateRoute,
  } as any)
const appDashboardInvoiceExceptionDocumentIdRoute =
  appDashboardInvoiceExceptionDocumentIdRouteImport.update({
    id: '/invoice-exception/$documentId',
    path: '/invoice-exception/$documentId',
    getParentRoute: () => appDashboardRoute,
  } as any)
const appDashboardGatewayEndpointsRoute =
  appDashboardGatewayEndpointsRouteImport.update({
    id: '/gateway/endpoints',
    path: '/gateway/endpoints',
    getParentRoute: () => appDashboardRoute,
  } as any)
const appDashboardGatewayCredentialsRoute =
  appDashboardGatewayCredentialsRouteImport.update({
    id: '/gateway/credentials',
    path: '/gateway/credentials',
    getParentRoute: () => appDashboardRoute,
  } as any)
const appDashboardBulkDocsReviewQueueRoute =
  appDashboardBulkDocsReviewQueueRouteImport.update({
    id: '/review-queue',
    path: '/review-queue',
    getParentRoute: () => appDashboardBulkDocsRoute,
  } as any)
const appDashboardAuditResponseCaseIdRoute =
  appDashboardAuditResponseCaseIdRouteImport.update({
    id: '/$caseId',
    path: '/$caseId',
    getParentRoute: () => appDashboardAuditResponseRoute,
  } as any)
const appDashboardAdvisorClientsRoute =
  appDashboardAdvisorClientsRouteImport.update({
    id: '/advisor/clients',
    path: '/advisor/clients',
    getParentRoute: () => appDashboardRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/management': typeof ManagementRoute
  '/workspace': typeof WorkspaceRoute
  '/dashboard': typeof appDashboardRouteWithChildren
  '/onboarding': typeof appOnboardingRoute
  '/accept-invite': typeof authAcceptInviteRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/login': typeof authLoginRoute
  '/register': typeof authRegisterRoute
  '/reset-password': typeof authResetPasswordRoute
  '/self-serve-signup': typeof authSelfServeSignupRouteWithChildren
  '/verify-email': typeof authVerifyEmailRoute
  '/dashboard/access-grants': typeof appDashboardAccessGrantsRoute
  '/dashboard/audit-readiness': typeof appDashboardAuditReadinessRoute
  '/dashboard/audit-response': typeof appDashboardAuditResponseRouteWithChildren
  '/dashboard/audit-risk': typeof appDashboardAuditRiskRoute
  '/dashboard/bulk-docs': typeof appDashboardBulkDocsRouteWithChildren
  '/dashboard/compliance-calendar': typeof appDashboardComplianceCalendarRoute
  '/dashboard/compliance-workspace': typeof appDashboardComplianceWorkspaceRoute
  '/dashboard/customs-trade': typeof appDashboardCustomsTradeRoute
  '/dashboard/developer': typeof appDashboardDeveloperRoute
  '/dashboard/etims-activation': typeof appDashboardEtimsActivationRoute
  '/dashboard/evidence': typeof appDashboardEvidenceRoute
  '/dashboard/gateway-audit': typeof appDashboardGatewayAuditRoute
  '/dashboard/invoice-gate': typeof appDashboardInvoiceGateRouteWithChildren
  '/dashboard/invoice-intelligence': typeof appDashboardInvoiceIntelligenceRoute
  '/dashboard/invoice-queue': typeof appDashboardInvoiceQueueRoute
  '/dashboard/invoice-repository': typeof appDashboardInvoiceRepositoryRoute
  '/dashboard/monitoring': typeof appDashboardMonitoringRoute
  '/dashboard/obligations': typeof appDashboardObligationsRouteWithChildren
  '/dashboard/onboarding-records': typeof appDashboardOnboardingRecordsRoute
  '/dashboard/onboarding-status': typeof appDashboardOnboardingStatusRoute
  '/dashboard/outbox': typeof appDashboardOutboxRoute
  '/dashboard/platform': typeof appDashboardPlatformRoute
  '/dashboard/products': typeof appDashboardProductsRoute
  '/dashboard/settings': typeof appDashboardSettingsRouteWithChildren
  '/dashboard/status': typeof appDashboardStatusRoute
  '/dashboard/suppliers': typeof appDashboardSuppliersRouteWithChildren
  '/dashboard/tax-readiness': typeof appDashboardTaxReadinessRoute
  '/dashboard/taxpulse': typeof appDashboardTaxpulseRoute
  '/dashboard/team': typeof appDashboardTeamRoute
  '/dashboard/tenants': typeof appDashboardTenantsRouteWithChildren
  '/dashboard/verifications': typeof appDashboardVerificationsRoute
  '/magic-link/verify': typeof authMagicLinkVerifyRoute
  '/self-serve-signup/verify': typeof authSelfServeSignupVerifyRoute
  '/docs': typeof publicPublicDocsRoute
  '/features': typeof publicPublicFeaturesRoute
  '/products': typeof publicPublicProductsRoute
  '/dashboard/': typeof appDashboardIndexRoute
  '/': typeof publicPublicIndexRoute
  '/dashboard/advisor/clients': typeof appDashboardAdvisorClientsRoute
  '/dashboard/audit-response/$caseId': typeof appDashboardAuditResponseCaseIdRoute
  '/dashboard/bulk-docs/review-queue': typeof appDashboardBulkDocsReviewQueueRoute
  '/dashboard/gateway/credentials': typeof appDashboardGatewayCredentialsRoute
  '/dashboard/gateway/endpoints': typeof appDashboardGatewayEndpointsRoute
  '/dashboard/invoice-exception/$documentId': typeof appDashboardInvoiceExceptionDocumentIdRoute
  '/dashboard/invoice-gate/$assessmentId': typeof appDashboardInvoiceGateAssessmentIdRoute
  '/dashboard/invoice-gate/batch': typeof appDashboardInvoiceGateBatchRoute
  '/dashboard/invoice-gate/new': typeof appDashboardInvoiceGateNewRoute
  '/dashboard/invoice-gate/review': typeof appDashboardInvoiceGateReviewRoute
  '/dashboard/obligations/$taxType': typeof appDashboardObligationsTaxTypeRoute
  '/dashboard/settings/billing': typeof appDashboardSettingsBillingRoute
  '/dashboard/settings/change-password': typeof appDashboardSettingsChangePasswordRoute
  '/dashboard/settings/user-profile': typeof appDashboardSettingsUserProfileRoute
  '/dashboard/suppliers/$supplierId': typeof appDashboardSuppliersSupplierIdRoute
  '/dashboard/tenants/$tenantPublicId': typeof appDashboardTenantsTenantPublicIdRoute
  '/solutions/$productId': typeof publicPublicSolutionsProductIdRoute
  '/tools/advisor': typeof publicPublicToolsAdvisorRoute
  '/tools/county-permits': typeof publicPublicToolsCountyPermitsRoute
  '/tools/deadline-calendar': typeof publicPublicToolsDeadlineCalendarRoute
  '/tools/deductibility': typeof publicPublicToolsDeductibilityRoute
  '/tools/etims-checklist': typeof publicPublicToolsEtimsChecklistRoute
  '/tools/invoice-ocr': typeof publicPublicToolsInvoiceOcrRoute
  '/tools/paye': typeof publicPublicToolsPayeRoute
  '/tools/penalty-estimator': typeof publicPublicToolsPenaltyEstimatorRoute
  '/tools/supplier-preview': typeof publicPublicToolsSupplierPreviewRoute
  '/tools/vat': typeof publicPublicToolsVatRoute
  '/tools/wht': typeof publicPublicToolsWhtRoute
  '/dashboard/audit-response/': typeof appDashboardAuditResponseIndexRoute
  '/dashboard/invoice-gate/': typeof appDashboardInvoiceGateIndexRoute
  '/dashboard/settings/': typeof appDashboardSettingsIndexRoute
  '/dashboard/tenants/': typeof appDashboardTenantsIndexRoute
}
export interface FileRoutesByTo {
  '/management': typeof ManagementRoute
  '/workspace': typeof WorkspaceRoute
  '/onboarding': typeof appOnboardingRoute
  '/accept-invite': typeof authAcceptInviteRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/login': typeof authLoginRoute
  '/register': typeof authRegisterRoute
  '/reset-password': typeof authResetPasswordRoute
  '/self-serve-signup': typeof authSelfServeSignupRouteWithChildren
  '/verify-email': typeof authVerifyEmailRoute
  '/dashboard/access-grants': typeof appDashboardAccessGrantsRoute
  '/dashboard/audit-readiness': typeof appDashboardAuditReadinessRoute
  '/dashboard/audit-risk': typeof appDashboardAuditRiskRoute
  '/dashboard/bulk-docs': typeof appDashboardBulkDocsRouteWithChildren
  '/dashboard/compliance-calendar': typeof appDashboardComplianceCalendarRoute
  '/dashboard/compliance-workspace': typeof appDashboardComplianceWorkspaceRoute
  '/dashboard/customs-trade': typeof appDashboardCustomsTradeRoute
  '/dashboard/developer': typeof appDashboardDeveloperRoute
  '/dashboard/etims-activation': typeof appDashboardEtimsActivationRoute
  '/dashboard/evidence': typeof appDashboardEvidenceRoute
  '/dashboard/gateway-audit': typeof appDashboardGatewayAuditRoute
  '/dashboard/invoice-intelligence': typeof appDashboardInvoiceIntelligenceRoute
  '/dashboard/invoice-queue': typeof appDashboardInvoiceQueueRoute
  '/dashboard/invoice-repository': typeof appDashboardInvoiceRepositoryRoute
  '/dashboard/monitoring': typeof appDashboardMonitoringRoute
  '/dashboard/obligations': typeof appDashboardObligationsRouteWithChildren
  '/dashboard/onboarding-records': typeof appDashboardOnboardingRecordsRoute
  '/dashboard/onboarding-status': typeof appDashboardOnboardingStatusRoute
  '/dashboard/outbox': typeof appDashboardOutboxRoute
  '/dashboard/platform': typeof appDashboardPlatformRoute
  '/dashboard/products': typeof appDashboardProductsRoute
  '/dashboard/status': typeof appDashboardStatusRoute
  '/dashboard/suppliers': typeof appDashboardSuppliersRouteWithChildren
  '/dashboard/tax-readiness': typeof appDashboardTaxReadinessRoute
  '/dashboard/taxpulse': typeof appDashboardTaxpulseRoute
  '/dashboard/team': typeof appDashboardTeamRoute
  '/dashboard/verifications': typeof appDashboardVerificationsRoute
  '/magic-link/verify': typeof authMagicLinkVerifyRoute
  '/self-serve-signup/verify': typeof authSelfServeSignupVerifyRoute
  '/docs': typeof publicPublicDocsRoute
  '/features': typeof publicPublicFeaturesRoute
  '/products': typeof publicPublicProductsRoute
  '/dashboard': typeof appDashboardIndexRoute
  '/': typeof publicPublicIndexRoute
  '/dashboard/advisor/clients': typeof appDashboardAdvisorClientsRoute
  '/dashboard/audit-response/$caseId': typeof appDashboardAuditResponseCaseIdRoute
  '/dashboard/bulk-docs/review-queue': typeof appDashboardBulkDocsReviewQueueRoute
  '/dashboard/gateway/credentials': typeof appDashboardGatewayCredentialsRoute
  '/dashboard/gateway/endpoints': typeof appDashboardGatewayEndpointsRoute
  '/dashboard/invoice-exception/$documentId': typeof appDashboardInvoiceExceptionDocumentIdRoute
  '/dashboard/invoice-gate/$assessmentId': typeof appDashboardInvoiceGateAssessmentIdRoute
  '/dashboard/invoice-gate/batch': typeof appDashboardInvoiceGateBatchRoute
  '/dashboard/invoice-gate/new': typeof appDashboardInvoiceGateNewRoute
  '/dashboard/invoice-gate/review': typeof appDashboardInvoiceGateReviewRoute
  '/dashboard/obligations/$taxType': typeof appDashboardObligationsTaxTypeRoute
  '/dashboard/settings/billing': typeof appDashboardSettingsBillingRoute
  '/dashboard/settings/change-password': typeof appDashboardSettingsChangePasswordRoute
  '/dashboard/settings/user-profile': typeof appDashboardSettingsUserProfileRoute
  '/dashboard/suppliers/$supplierId': typeof appDashboardSuppliersSupplierIdRoute
  '/dashboard/tenants/$tenantPublicId': typeof appDashboardTenantsTenantPublicIdRoute
  '/solutions/$productId': typeof publicPublicSolutionsProductIdRoute
  '/tools/advisor': typeof publicPublicToolsAdvisorRoute
  '/tools/county-permits': typeof publicPublicToolsCountyPermitsRoute
  '/tools/deadline-calendar': typeof publicPublicToolsDeadlineCalendarRoute
  '/tools/deductibility': typeof publicPublicToolsDeductibilityRoute
  '/tools/etims-checklist': typeof publicPublicToolsEtimsChecklistRoute
  '/tools/invoice-ocr': typeof publicPublicToolsInvoiceOcrRoute
  '/tools/paye': typeof publicPublicToolsPayeRoute
  '/tools/penalty-estimator': typeof publicPublicToolsPenaltyEstimatorRoute
  '/tools/supplier-preview': typeof publicPublicToolsSupplierPreviewRoute
  '/tools/vat': typeof publicPublicToolsVatRoute
  '/tools/wht': typeof publicPublicToolsWhtRoute
  '/dashboard/audit-response': typeof appDashboardAuditResponseIndexRoute
  '/dashboard/invoice-gate': typeof appDashboardInvoiceGateIndexRoute
  '/dashboard/settings': typeof appDashboardSettingsIndexRoute
  '/dashboard/tenants': typeof appDashboardTenantsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/management': typeof ManagementRoute
  '/workspace': typeof WorkspaceRoute
  '/(app)/dashboard': typeof appDashboardRouteWithChildren
  '/(app)/onboarding': typeof appOnboardingRoute
  '/(auth)/accept-invite': typeof authAcceptInviteRoute
  '/(auth)/forgot-password': typeof authForgotPasswordRoute
  '/(auth)/login': typeof authLoginRoute
  '/(auth)/register': typeof authRegisterRoute
  '/(auth)/reset-password': typeof authResetPasswordRoute
  '/(auth)/self-serve-signup': typeof authSelfServeSignupRouteWithChildren
  '/(auth)/verify-email': typeof authVerifyEmailRoute
  '/(public)/_public': typeof publicPublicRouteWithChildren
  '/(app)/dashboard/access-grants': typeof appDashboardAccessGrantsRoute
  '/(app)/dashboard/audit-readiness': typeof appDashboardAuditReadinessRoute
  '/(app)/dashboard/audit-response': typeof appDashboardAuditResponseRouteWithChildren
  '/(app)/dashboard/audit-risk': typeof appDashboardAuditRiskRoute
  '/(app)/dashboard/bulk-docs': typeof appDashboardBulkDocsRouteWithChildren
  '/(app)/dashboard/compliance-calendar': typeof appDashboardComplianceCalendarRoute
  '/(app)/dashboard/compliance-workspace': typeof appDashboardComplianceWorkspaceRoute
  '/(app)/dashboard/customs-trade': typeof appDashboardCustomsTradeRoute
  '/(app)/dashboard/developer': typeof appDashboardDeveloperRoute
  '/(app)/dashboard/etims-activation': typeof appDashboardEtimsActivationRoute
  '/(app)/dashboard/evidence': typeof appDashboardEvidenceRoute
  '/(app)/dashboard/gateway-audit': typeof appDashboardGatewayAuditRoute
  '/(app)/dashboard/invoice-gate': typeof appDashboardInvoiceGateRouteWithChildren
  '/(app)/dashboard/invoice-intelligence': typeof appDashboardInvoiceIntelligenceRoute
  '/(app)/dashboard/invoice-queue': typeof appDashboardInvoiceQueueRoute
  '/(app)/dashboard/invoice-repository': typeof appDashboardInvoiceRepositoryRoute
  '/(app)/dashboard/monitoring': typeof appDashboardMonitoringRoute
  '/(app)/dashboard/obligations': typeof appDashboardObligationsRouteWithChildren
  '/(app)/dashboard/onboarding-records': typeof appDashboardOnboardingRecordsRoute
  '/(app)/dashboard/onboarding-status': typeof appDashboardOnboardingStatusRoute
  '/(app)/dashboard/outbox': typeof appDashboardOutboxRoute
  '/(app)/dashboard/platform': typeof appDashboardPlatformRoute
  '/(app)/dashboard/products': typeof appDashboardProductsRoute
  '/(app)/dashboard/settings': typeof appDashboardSettingsRouteWithChildren
  '/(app)/dashboard/status': typeof appDashboardStatusRoute
  '/(app)/dashboard/suppliers': typeof appDashboardSuppliersRouteWithChildren
  '/(app)/dashboard/tax-readiness': typeof appDashboardTaxReadinessRoute
  '/(app)/dashboard/taxpulse': typeof appDashboardTaxpulseRoute
  '/(app)/dashboard/team': typeof appDashboardTeamRoute
  '/(app)/dashboard/tenants': typeof appDashboardTenantsRouteWithChildren
  '/(app)/dashboard/verifications': typeof appDashboardVerificationsRoute
  '/(auth)/magic-link/verify': typeof authMagicLinkVerifyRoute
  '/(auth)/self-serve-signup/verify': typeof authSelfServeSignupVerifyRoute
  '/(public)/_public/docs': typeof publicPublicDocsRoute
  '/(public)/_public/features': typeof publicPublicFeaturesRoute
  '/(public)/_public/products': typeof publicPublicProductsRoute
  '/(app)/dashboard/': typeof appDashboardIndexRoute
  '/(public)/_public/': typeof publicPublicIndexRoute
  '/(app)/dashboard/advisor/clients': typeof appDashboardAdvisorClientsRoute
  '/(app)/dashboard/audit-response/$caseId': typeof appDashboardAuditResponseCaseIdRoute
  '/(app)/dashboard/bulk-docs/review-queue': typeof appDashboardBulkDocsReviewQueueRoute
  '/(app)/dashboard/gateway/credentials': typeof appDashboardGatewayCredentialsRoute
  '/(app)/dashboard/gateway/endpoints': typeof appDashboardGatewayEndpointsRoute
  '/(app)/dashboard/invoice-exception/$documentId': typeof appDashboardInvoiceExceptionDocumentIdRoute
  '/(app)/dashboard/invoice-gate/$assessmentId': typeof appDashboardInvoiceGateAssessmentIdRoute
  '/(app)/dashboard/invoice-gate/batch': typeof appDashboardInvoiceGateBatchRoute
  '/(app)/dashboard/invoice-gate/new': typeof appDashboardInvoiceGateNewRoute
  '/(app)/dashboard/invoice-gate/review': typeof appDashboardInvoiceGateReviewRoute
  '/(app)/dashboard/obligations/$taxType': typeof appDashboardObligationsTaxTypeRoute
  '/(app)/dashboard/settings/billing': typeof appDashboardSettingsBillingRoute
  '/(app)/dashboard/settings/change-password': typeof appDashboardSettingsChangePasswordRoute
  '/(app)/dashboard/settings/user-profile': typeof appDashboardSettingsUserProfileRoute
  '/(app)/dashboard/suppliers/$supplierId': typeof appDashboardSuppliersSupplierIdRoute
  '/(app)/dashboard/tenants/$tenantPublicId': typeof appDashboardTenantsTenantPublicIdRoute
  '/(public)/_public/solutions/$productId': typeof publicPublicSolutionsProductIdRoute
  '/(public)/_public/tools/advisor': typeof publicPublicToolsAdvisorRoute
  '/(public)/_public/tools/county-permits': typeof publicPublicToolsCountyPermitsRoute
  '/(public)/_public/tools/deadline-calendar': typeof publicPublicToolsDeadlineCalendarRoute
  '/(public)/_public/tools/deductibility': typeof publicPublicToolsDeductibilityRoute
  '/(public)/_public/tools/etims-checklist': typeof publicPublicToolsEtimsChecklistRoute
  '/(public)/_public/tools/invoice-ocr': typeof publicPublicToolsInvoiceOcrRoute
  '/(public)/_public/tools/paye': typeof publicPublicToolsPayeRoute
  '/(public)/_public/tools/penalty-estimator': typeof publicPublicToolsPenaltyEstimatorRoute
  '/(public)/_public/tools/supplier-preview': typeof publicPublicToolsSupplierPreviewRoute
  '/(public)/_public/tools/vat': typeof publicPublicToolsVatRoute
  '/(public)/_public/tools/wht': typeof publicPublicToolsWhtRoute
  '/(app)/dashboard/audit-response/': typeof appDashboardAuditResponseIndexRoute
  '/(app)/dashboard/invoice-gate/': typeof appDashboardInvoiceGateIndexRoute
  '/(app)/dashboard/settings/': typeof appDashboardSettingsIndexRoute
  '/(app)/dashboard/tenants/': typeof appDashboardTenantsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/management'
    | '/workspace'
    | '/dashboard'
    | '/onboarding'
    | '/accept-invite'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/self-serve-signup'
    | '/verify-email'
    | '/dashboard/access-grants'
    | '/dashboard/audit-readiness'
    | '/dashboard/audit-response'
    | '/dashboard/audit-risk'
    | '/dashboard/bulk-docs'
    | '/dashboard/compliance-calendar'
    | '/dashboard/compliance-workspace'
    | '/dashboard/customs-trade'
    | '/dashboard/developer'
    | '/dashboard/etims-activation'
    | '/dashboard/evidence'
    | '/dashboard/gateway-audit'
    | '/dashboard/invoice-gate'
    | '/dashboard/invoice-intelligence'
    | '/dashboard/invoice-queue'
    | '/dashboard/invoice-repository'
    | '/dashboard/monitoring'
    | '/dashboard/obligations'
    | '/dashboard/onboarding-records'
    | '/dashboard/onboarding-status'
    | '/dashboard/outbox'
    | '/dashboard/platform'
    | '/dashboard/products'
    | '/dashboard/settings'
    | '/dashboard/status'
    | '/dashboard/suppliers'
    | '/dashboard/tax-readiness'
    | '/dashboard/taxpulse'
    | '/dashboard/team'
    | '/dashboard/tenants'
    | '/dashboard/verifications'
    | '/magic-link/verify'
    | '/self-serve-signup/verify'
    | '/docs'
    | '/features'
    | '/products'
    | '/dashboard/'
    | '/'
    | '/dashboard/advisor/clients'
    | '/dashboard/audit-response/$caseId'
    | '/dashboard/bulk-docs/review-queue'
    | '/dashboard/gateway/credentials'
    | '/dashboard/gateway/endpoints'
    | '/dashboard/invoice-exception/$documentId'
    | '/dashboard/invoice-gate/$assessmentId'
    | '/dashboard/invoice-gate/batch'
    | '/dashboard/invoice-gate/new'
    | '/dashboard/invoice-gate/review'
    | '/dashboard/obligations/$taxType'
    | '/dashboard/settings/billing'
    | '/dashboard/settings/change-password'
    | '/dashboard/settings/user-profile'
    | '/dashboard/suppliers/$supplierId'
    | '/dashboard/tenants/$tenantPublicId'
    | '/solutions/$productId'
    | '/tools/advisor'
    | '/tools/county-permits'
    | '/tools/deadline-calendar'
    | '/tools/deductibility'
    | '/tools/etims-checklist'
    | '/tools/invoice-ocr'
    | '/tools/paye'
    | '/tools/penalty-estimator'
    | '/tools/supplier-preview'
    | '/tools/vat'
    | '/tools/wht'
    | '/dashboard/audit-response/'
    | '/dashboard/invoice-gate/'
    | '/dashboard/settings/'
    | '/dashboard/tenants/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/management'
    | '/workspace'
    | '/onboarding'
    | '/accept-invite'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/self-serve-signup'
    | '/verify-email'
    | '/dashboard/access-grants'
    | '/dashboard/audit-readiness'
    | '/dashboard/audit-risk'
    | '/dashboard/bulk-docs'
    | '/dashboard/compliance-calendar'
    | '/dashboard/compliance-workspace'
    | '/dashboard/customs-trade'
    | '/dashboard/developer'
    | '/dashboard/etims-activation'
    | '/dashboard/evidence'
    | '/dashboard/gateway-audit'
    | '/dashboard/invoice-intelligence'
    | '/dashboard/invoice-queue'
    | '/dashboard/invoice-repository'
    | '/dashboard/monitoring'
    | '/dashboard/obligations'
    | '/dashboard/onboarding-records'
    | '/dashboard/onboarding-status'
    | '/dashboard/outbox'
    | '/dashboard/platform'
    | '/dashboard/products'
    | '/dashboard/status'
    | '/dashboard/suppliers'
    | '/dashboard/tax-readiness'
    | '/dashboard/taxpulse'
    | '/dashboard/team'
    | '/dashboard/verifications'
    | '/magic-link/verify'
    | '/self-serve-signup/verify'
    | '/docs'
    | '/features'
    | '/products'
    | '/dashboard'
    | '/'
    | '/dashboard/advisor/clients'
    | '/dashboard/audit-response/$caseId'
    | '/dashboard/bulk-docs/review-queue'
    | '/dashboard/gateway/credentials'
    | '/dashboard/gateway/endpoints'
    | '/dashboard/invoice-exception/$documentId'
    | '/dashboard/invoice-gate/$assessmentId'
    | '/dashboard/invoice-gate/batch'
    | '/dashboard/invoice-gate/new'
    | '/dashboard/invoice-gate/review'
    | '/dashboard/obligations/$taxType'
    | '/dashboard/settings/billing'
    | '/dashboard/settings/change-password'
    | '/dashboard/settings/user-profile'
    | '/dashboard/suppliers/$supplierId'
    | '/dashboard/tenants/$tenantPublicId'
    | '/solutions/$productId'
    | '/tools/advisor'
    | '/tools/county-permits'
    | '/tools/deadline-calendar'
    | '/tools/deductibility'
    | '/tools/etims-checklist'
    | '/tools/invoice-ocr'
    | '/tools/paye'
    | '/tools/penalty-estimator'
    | '/tools/supplier-preview'
    | '/tools/vat'
    | '/tools/wht'
    | '/dashboard/audit-response'
    | '/dashboard/invoice-gate'
    | '/dashboard/settings'
    | '/dashboard/tenants'
  id:
    | '__root__'
    | '/management'
    | '/workspace'
    | '/(app)/dashboard'
    | '/(app)/onboarding'
    | '/(auth)/accept-invite'
    | '/(auth)/forgot-password'
    | '/(auth)/login'
    | '/(auth)/register'
    | '/(auth)/reset-password'
    | '/(auth)/self-serve-signup'
    | '/(auth)/verify-email'
    | '/(public)/_public'
    | '/(app)/dashboard/access-grants'
    | '/(app)/dashboard/audit-readiness'
    | '/(app)/dashboard/audit-response'
    | '/(app)/dashboard/audit-risk'
    | '/(app)/dashboard/bulk-docs'
    | '/(app)/dashboard/compliance-calendar'
    | '/(app)/dashboard/compliance-workspace'
    | '/(app)/dashboard/customs-trade'
    | '/(app)/dashboard/developer'
    | '/(app)/dashboard/etims-activation'
    | '/(app)/dashboard/evidence'
    | '/(app)/dashboard/gateway-audit'
    | '/(app)/dashboard/invoice-gate'
    | '/(app)/dashboard/invoice-intelligence'
    | '/(app)/dashboard/invoice-queue'
    | '/(app)/dashboard/invoice-repository'
    | '/(app)/dashboard/monitoring'
    | '/(app)/dashboard/obligations'
    | '/(app)/dashboard/onboarding-records'
    | '/(app)/dashboard/onboarding-status'
    | '/(app)/dashboard/outbox'
    | '/(app)/dashboard/platform'
    | '/(app)/dashboard/products'
    | '/(app)/dashboard/settings'
    | '/(app)/dashboard/status'
    | '/(app)/dashboard/suppliers'
    | '/(app)/dashboard/tax-readiness'
    | '/(app)/dashboard/taxpulse'
    | '/(app)/dashboard/team'
    | '/(app)/dashboard/tenants'
    | '/(app)/dashboard/verifications'
    | '/(auth)/magic-link/verify'
    | '/(auth)/self-serve-signup/verify'
    | '/(public)/_public/docs'
    | '/(public)/_public/features'
    | '/(public)/_public/products'
    | '/(app)/dashboard/'
    | '/(public)/_public/'
    | '/(app)/dashboard/advisor/clients'
    | '/(app)/dashboard/audit-response/$caseId'
    | '/(app)/dashboard/bulk-docs/review-queue'
    | '/(app)/dashboard/gateway/credentials'
    | '/(app)/dashboard/gateway/endpoints'
    | '/(app)/dashboard/invoice-exception/$documentId'
    | '/(app)/dashboard/invoice-gate/$assessmentId'
    | '/(app)/dashboard/invoice-gate/batch'
    | '/(app)/dashboard/invoice-gate/new'
    | '/(app)/dashboard/invoice-gate/review'
    | '/(app)/dashboard/obligations/$taxType'
    | '/(app)/dashboard/settings/billing'
    | '/(app)/dashboard/settings/change-password'
    | '/(app)/dashboard/settings/user-profile'
    | '/(app)/dashboard/suppliers/$supplierId'
    | '/(app)/dashboard/tenants/$tenantPublicId'
    | '/(public)/_public/solutions/$productId'
    | '/(public)/_public/tools/advisor'
    | '/(public)/_public/tools/county-permits'
    | '/(public)/_public/tools/deadline-calendar'
    | '/(public)/_public/tools/deductibility'
    | '/(public)/_public/tools/etims-checklist'
    | '/(public)/_public/tools/invoice-ocr'
    | '/(public)/_public/tools/paye'
    | '/(public)/_public/tools/penalty-estimator'
    | '/(public)/_public/tools/supplier-preview'
    | '/(public)/_public/tools/vat'
    | '/(public)/_public/tools/wht'
    | '/(app)/dashboard/audit-response/'
    | '/(app)/dashboard/invoice-gate/'
    | '/(app)/dashboard/settings/'
    | '/(app)/dashboard/tenants/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ManagementRoute: typeof ManagementRoute
  WorkspaceRoute: typeof WorkspaceRoute
  appDashboardRoute: typeof appDashboardRouteWithChildren
  appOnboardingRoute: typeof appOnboardingRoute
  authAcceptInviteRoute: typeof authAcceptInviteRoute
  authForgotPasswordRoute: typeof authForgotPasswordRoute
  authLoginRoute: typeof authLoginRoute
  authRegisterRoute: typeof authRegisterRoute
  authResetPasswordRoute: typeof authResetPasswordRoute
  authSelfServeSignupRoute: typeof authSelfServeSignupRouteWithChildren
  authVerifyEmailRoute: typeof authVerifyEmailRoute
  publicPublicRoute: typeof publicPublicRouteWithChildren
  authMagicLinkVerifyRoute: typeof authMagicLinkVerifyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/workspace': {
      id: '/workspace'
      path: '/workspace'
      fullPath: '/workspace'
      preLoaderRoute: typeof WorkspaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/management': {
      id: '/management'
      path: '/management'
      fullPath: '/management'
      preLoaderRoute: typeof ManagementRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/_public': {
      id: '/(public)/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof publicPublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/verify-email': {
      id: '/(auth)/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof authVerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/self-serve-signup': {
      id: '/(auth)/self-serve-signup'
      path: '/self-serve-signup'
      fullPath: '/self-serve-signup'
      preLoaderRoute: typeof authSelfServeSignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/reset-password': {
      id: '/(auth)/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof authResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/register': {
      id: '/(auth)/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof authRegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/login': {
      id: '/(auth)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof authLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/accept-invite': {
      id: '/(auth)/accept-invite'
      path: '/accept-invite'
      fullPath: '/accept-invite'
      preLoaderRoute: typeof authAcceptInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/onboarding': {
      id: '/(app)/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof appOnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/dashboard': {
      id: '/(app)/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof appDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/_public/': {
      id: '/(public)/_public/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof publicPublicIndexRouteImport
      parentRoute: typeof publicPublicRoute
    }
    '/(app)/dashboard/': {
      id: '/(app)/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof appDashboardIndexRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(public)/_public/products': {
      id: '/(public)/_public/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof publicPublicProductsRouteImport
      parentRoute: typeof publicPublicRoute
    }
    '/(public)/_public/features': {
      id: '/(public)/_public/features'
      path: '/features'
      fullPath: '/features'
      preLoaderRoute: typeof publicPublicFeaturesRouteImport
      parentRoute: typeof publicPublicRoute
    }
    '/(public)/_public/docs': {
      id: '/(public)/_public/docs'
      path: '/docs'
      fullPath: '/docs'
      preLoaderRoute: typeof publicPublicDocsRouteImport
      parentRoute: typeof publicPublicRoute
    }
    '/(auth)/self-serve-signup/verify': {
      id: '/(auth)/self-serve-signup/verify'
      path: '/verify'
      fullPath: '/self-serve-signup/verify'
      preLoaderRoute: typeof authSelfServeSignupVerifyRouteImport
      parentRoute: typeof authSelfServeSignupRoute
    }
    '/(auth)/magic-link/verify': {
      id: '/(auth)/magic-link/verify'
      path: '/magic-link/verify'
      fullPath: '/magic-link/verify'
      preLoaderRoute: typeof authMagicLinkVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/dashboard/verifications': {
      id: '/(app)/dashboard/verifications'
      path: '/verifications'
      fullPath: '/dashboard/verifications'
      preLoaderRoute: typeof appDashboardVerificationsRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/tenants': {
      id: '/(app)/dashboard/tenants'
      path: '/tenants'
      fullPath: '/dashboard/tenants'
      preLoaderRoute: typeof appDashboardTenantsRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/team': {
      id: '/(app)/dashboard/team'
      path: '/team'
      fullPath: '/dashboard/team'
      preLoaderRoute: typeof appDashboardTeamRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/taxpulse': {
      id: '/(app)/dashboard/taxpulse'
      path: '/taxpulse'
      fullPath: '/dashboard/taxpulse'
      preLoaderRoute: typeof appDashboardTaxpulseRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/tax-readiness': {
      id: '/(app)/dashboard/tax-readiness'
      path: '/tax-readiness'
      fullPath: '/dashboard/tax-readiness'
      preLoaderRoute: typeof appDashboardTaxReadinessRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/suppliers': {
      id: '/(app)/dashboard/suppliers'
      path: '/suppliers'
      fullPath: '/dashboard/suppliers'
      preLoaderRoute: typeof appDashboardSuppliersRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/status': {
      id: '/(app)/dashboard/status'
      path: '/status'
      fullPath: '/dashboard/status'
      preLoaderRoute: typeof appDashboardStatusRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/settings': {
      id: '/(app)/dashboard/settings'
      path: '/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof appDashboardSettingsRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/products': {
      id: '/(app)/dashboard/products'
      path: '/products'
      fullPath: '/dashboard/products'
      preLoaderRoute: typeof appDashboardProductsRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/platform': {
      id: '/(app)/dashboard/platform'
      path: '/platform'
      fullPath: '/dashboard/platform'
      preLoaderRoute: typeof appDashboardPlatformRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/outbox': {
      id: '/(app)/dashboard/outbox'
      path: '/outbox'
      fullPath: '/dashboard/outbox'
      preLoaderRoute: typeof appDashboardOutboxRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/onboarding-status': {
      id: '/(app)/dashboard/onboarding-status'
      path: '/onboarding-status'
      fullPath: '/dashboard/onboarding-status'
      preLoaderRoute: typeof appDashboardOnboardingStatusRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/onboarding-records': {
      id: '/(app)/dashboard/onboarding-records'
      path: '/onboarding-records'
      fullPath: '/dashboard/onboarding-records'
      preLoaderRoute: typeof appDashboardOnboardingRecordsRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/obligations': {
      id: '/(app)/dashboard/obligations'
      path: '/obligations'
      fullPath: '/dashboard/obligations'
      preLoaderRoute: typeof appDashboardObligationsRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/monitoring': {
      id: '/(app)/dashboard/monitoring'
      path: '/monitoring'
      fullPath: '/dashboard/monitoring'
      preLoaderRoute: typeof appDashboardMonitoringRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/invoice-repository': {
      id: '/(app)/dashboard/invoice-repository'
      path: '/invoice-repository'
      fullPath: '/dashboard/invoice-repository'
      preLoaderRoute: typeof appDashboardInvoiceRepositoryRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/invoice-queue': {
      id: '/(app)/dashboard/invoice-queue'
      path: '/invoice-queue'
      fullPath: '/dashboard/invoice-queue'
      preLoaderRoute: typeof appDashboardInvoiceQueueRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/invoice-intelligence': {
      id: '/(app)/dashboard/invoice-intelligence'
      path: '/invoice-intelligence'
      fullPath: '/dashboard/invoice-intelligence'
      preLoaderRoute: typeof appDashboardInvoiceIntelligenceRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/invoice-gate': {
      id: '/(app)/dashboard/invoice-gate'
      path: '/invoice-gate'
      fullPath: '/dashboard/invoice-gate'
      preLoaderRoute: typeof appDashboardInvoiceGateRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/gateway-audit': {
      id: '/(app)/dashboard/gateway-audit'
      path: '/gateway-audit'
      fullPath: '/dashboard/gateway-audit'
      preLoaderRoute: typeof appDashboardGatewayAuditRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/evidence': {
      id: '/(app)/dashboard/evidence'
      path: '/evidence'
      fullPath: '/dashboard/evidence'
      preLoaderRoute: typeof appDashboardEvidenceRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/etims-activation': {
      id: '/(app)/dashboard/etims-activation'
      path: '/etims-activation'
      fullPath: '/dashboard/etims-activation'
      preLoaderRoute: typeof appDashboardEtimsActivationRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/developer': {
      id: '/(app)/dashboard/developer'
      path: '/developer'
      fullPath: '/dashboard/developer'
      preLoaderRoute: typeof appDashboardDeveloperRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/customs-trade': {
      id: '/(app)/dashboard/customs-trade'
      path: '/customs-trade'
      fullPath: '/dashboard/customs-trade'
      preLoaderRoute: typeof appDashboardCustomsTradeRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/compliance-workspace': {
      id: '/(app)/dashboard/compliance-workspace'
      path: '/compliance-workspace'
      fullPath: '/dashboard/compliance-workspace'
      preLoaderRoute: typeof appDashboardComplianceWorkspaceRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/compliance-calendar': {
      id: '/(app)/dashboard/compliance-calendar'
      path: '/compliance-calendar'
      fullPath: '/dashboard/compliance-calendar'
      preLoaderRoute: typeof appDashboardComplianceCalendarRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/bulk-docs': {
      id: '/(app)/dashboard/bulk-docs'
      path: '/bulk-docs'
      fullPath: '/dashboard/bulk-docs'
      preLoaderRoute: typeof appDashboardBulkDocsRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/audit-risk': {
      id: '/(app)/dashboard/audit-risk'
      path: '/audit-risk'
      fullPath: '/dashboard/audit-risk'
      preLoaderRoute: typeof appDashboardAuditRiskRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/audit-response': {
      id: '/(app)/dashboard/audit-response'
      path: '/audit-response'
      fullPath: '/dashboard/audit-response'
      preLoaderRoute: typeof appDashboardAuditResponseRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/audit-readiness': {
      id: '/(app)/dashboard/audit-readiness'
      path: '/audit-readiness'
      fullPath: '/dashboard/audit-readiness'
      preLoaderRoute: typeof appDashboardAuditReadinessRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/access-grants': {
      id: '/(app)/dashboard/access-grants'
      path: '/access-grants'
      fullPath: '/dashboard/access-grants'
      preLoaderRoute: typeof appDashboardAccessGrantsRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/tenants/': {
      id: '/(app)/dashboard/tenants/'
      path: '/'
      fullPath: '/dashboard/tenants/'
      preLoaderRoute: typeof appDashboardTenantsIndexRouteImport
      parentRoute: typeof appDashboardTenantsRoute
    }
    '/(app)/dashboard/settings/': {
      id: '/(app)/dashboard/settings/'
      path: '/'
      fullPath: '/dashboard/settings/'
      preLoaderRoute: typeof appDashboardSettingsIndexRouteImport
      parentRoute: typeof appDashboardSettingsRoute
    }
    '/(app)/dashboard/invoice-gate/': {
      id: '/(app)/dashboard/invoice-gate/'
      path: '/'
      fullPath: '/dashboard/invoice-gate/'
      preLoaderRoute: typeof appDashboardInvoiceGateIndexRouteImport
      parentRoute: typeof appDashboardInvoiceGateRoute
    }
    '/(app)/dashboard/audit-response/': {
      id: '/(app)/dashboard/audit-response/'
      path: '/'
      fullPath: '/dashboard/audit-response/'
      preLoaderRoute: typeof appDashboardAuditResponseIndexRouteImport
      parentRoute: typeof appDashboardAuditResponseRoute
    }
    '/(public)/_public/tools/wht': {
      id: '/(public)/_public/tools/wht'
      path: '/tools/wht'
      fullPath: '/tools/wht'
      preLoaderRoute: typeof publicPublicToolsWhtRouteImport
      parentRoute: typeof publicPublicRoute
    }
    '/(public)/_public/tools/vat': {
      id: '/(public)/_public/tools/vat'
      path: '/tools/vat'
      fullPath: '/tools/vat'
      preLoaderRoute: typeof publicPublicToolsVatRouteImport
      parentRoute: typeof publicPublicRoute
    }
    '/(public)/_public/tools/supplier-preview': {
      id: '/(public)/_public/tools/supplier-preview'
      path: '/tools/supplier-preview'
      fullPath: '/tools/supplier-preview'
      preLoaderRoute: typeof publicPublicToolsSupplierPreviewRouteImport
      parentRoute: typeof publicPublicRoute
    }
    '/(public)/_public/tools/penalty-estimator': {
      id: '/(public)/_public/tools/penalty-estimator'
      path: '/tools/penalty-estimator'
      fullPath: '/tools/penalty-estimator'
      preLoaderRoute: typeof publicPublicToolsPenaltyEstimatorRouteImport
      parentRoute: typeof publicPublicRoute
    }
    '/(public)/_public/tools/paye': {
      id: '/(public)/_public/tools/paye'
      path: '/tools/paye'
      fullPath: '/tools/paye'
      preLoaderRoute: typeof publicPublicToolsPayeRouteImport
      parentRoute: typeof publicPublicRoute
    }
    '/(public)/_public/tools/invoice-ocr': {
      id: '/(public)/_public/tools/invoice-ocr'
      path: '/tools/invoice-ocr'
      fullPath: '/tools/invoice-ocr'
      preLoaderRoute: typeof publicPublicToolsInvoiceOcrRouteImport
      parentRoute: typeof publicPublicRoute
    }
    '/(public)/_public/tools/etims-checklist': {
      id: '/(public)/_public/tools/etims-checklist'
      path: '/tools/etims-checklist'
      fullPath: '/tools/etims-checklist'
      preLoaderRoute: typeof publicPublicToolsEtimsChecklistRouteImport
      parentRoute: typeof publicPublicRoute
    }
    '/(public)/_public/tools/deductibility': {
      id: '/(public)/_public/tools/deductibility'
      path: '/tools/deductibility'
      fullPath: '/tools/deductibility'
      preLoaderRoute: typeof publicPublicToolsDeductibilityRouteImport
      parentRoute: typeof publicPublicRoute
    }
    '/(public)/_public/tools/deadline-calendar': {
      id: '/(public)/_public/tools/deadline-calendar'
      path: '/tools/deadline-calendar'
      fullPath: '/tools/deadline-calendar'
      preLoaderRoute: typeof publicPublicToolsDeadlineCalendarRouteImport
      parentRoute: typeof publicPublicRoute
    }
    '/(public)/_public/tools/county-permits': {
      id: '/(public)/_public/tools/county-permits'
      path: '/tools/county-permits'
      fullPath: '/tools/county-permits'
      preLoaderRoute: typeof publicPublicToolsCountyPermitsRouteImport
      parentRoute: typeof publicPublicRoute
    }
    '/(public)/_public/tools/advisor': {
      id: '/(public)/_public/tools/advisor'
      path: '/tools/advisor'
      fullPath: '/tools/advisor'
      preLoaderRoute: typeof publicPublicToolsAdvisorRouteImport
      parentRoute: typeof publicPublicRoute
    }
    '/(public)/_public/solutions/$productId': {
      id: '/(public)/_public/solutions/$productId'
      path: '/solutions/$productId'
      fullPath: '/solutions/$productId'
      preLoaderRoute: typeof publicPublicSolutionsProductIdRouteImport
      parentRoute: typeof publicPublicRoute
    }
    '/(app)/dashboard/tenants/$tenantPublicId': {
      id: '/(app)/dashboard/tenants/$tenantPublicId'
      path: '/$tenantPublicId'
      fullPath: '/dashboard/tenants/$tenantPublicId'
      preLoaderRoute: typeof appDashboardTenantsTenantPublicIdRouteImport
      parentRoute: typeof appDashboardTenantsRoute
    }
    '/(app)/dashboard/suppliers/$supplierId': {
      id: '/(app)/dashboard/suppliers/$supplierId'
      path: '/$supplierId'
      fullPath: '/dashboard/suppliers/$supplierId'
      preLoaderRoute: typeof appDashboardSuppliersSupplierIdRouteImport
      parentRoute: typeof appDashboardSuppliersRoute
    }
    '/(app)/dashboard/settings/user-profile': {
      id: '/(app)/dashboard/settings/user-profile'
      path: '/user-profile'
      fullPath: '/dashboard/settings/user-profile'
      preLoaderRoute: typeof appDashboardSettingsUserProfileRouteImport
      parentRoute: typeof appDashboardSettingsRoute
    }
    '/(app)/dashboard/settings/change-password': {
      id: '/(app)/dashboard/settings/change-password'
      path: '/change-password'
      fullPath: '/dashboard/settings/change-password'
      preLoaderRoute: typeof appDashboardSettingsChangePasswordRouteImport
      parentRoute: typeof appDashboardSettingsRoute
    }
    '/(app)/dashboard/settings/billing': {
      id: '/(app)/dashboard/settings/billing'
      path: '/billing'
      fullPath: '/dashboard/settings/billing'
      preLoaderRoute: typeof appDashboardSettingsBillingRouteImport
      parentRoute: typeof appDashboardSettingsRoute
    }
    '/(app)/dashboard/obligations/$taxType': {
      id: '/(app)/dashboard/obligations/$taxType'
      path: '/$taxType'
      fullPath: '/dashboard/obligations/$taxType'
      preLoaderRoute: typeof appDashboardObligationsTaxTypeRouteImport
      parentRoute: typeof appDashboardObligationsRoute
    }
    '/(app)/dashboard/invoice-gate/review': {
      id: '/(app)/dashboard/invoice-gate/review'
      path: '/review'
      fullPath: '/dashboard/invoice-gate/review'
      preLoaderRoute: typeof appDashboardInvoiceGateReviewRouteImport
      parentRoute: typeof appDashboardInvoiceGateRoute
    }
    '/(app)/dashboard/invoice-gate/new': {
      id: '/(app)/dashboard/invoice-gate/new'
      path: '/new'
      fullPath: '/dashboard/invoice-gate/new'
      preLoaderRoute: typeof appDashboardInvoiceGateNewRouteImport
      parentRoute: typeof appDashboardInvoiceGateRoute
    }
    '/(app)/dashboard/invoice-gate/batch': {
      id: '/(app)/dashboard/invoice-gate/batch'
      path: '/batch'
      fullPath: '/dashboard/invoice-gate/batch'
      preLoaderRoute: typeof appDashboardInvoiceGateBatchRouteImport
      parentRoute: typeof appDashboardInvoiceGateRoute
    }
    '/(app)/dashboard/invoice-gate/$assessmentId': {
      id: '/(app)/dashboard/invoice-gate/$assessmentId'
      path: '/$assessmentId'
      fullPath: '/dashboard/invoice-gate/$assessmentId'
      preLoaderRoute: typeof appDashboardInvoiceGateAssessmentIdRouteImport
      parentRoute: typeof appDashboardInvoiceGateRoute
    }
    '/(app)/dashboard/invoice-exception/$documentId': {
      id: '/(app)/dashboard/invoice-exception/$documentId'
      path: '/invoice-exception/$documentId'
      fullPath: '/dashboard/invoice-exception/$documentId'
      preLoaderRoute: typeof appDashboardInvoiceExceptionDocumentIdRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/gateway/endpoints': {
      id: '/(app)/dashboard/gateway/endpoints'
      path: '/gateway/endpoints'
      fullPath: '/dashboard/gateway/endpoints'
      preLoaderRoute: typeof appDashboardGatewayEndpointsRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/gateway/credentials': {
      id: '/(app)/dashboard/gateway/credentials'
      path: '/gateway/credentials'
      fullPath: '/dashboard/gateway/credentials'
      preLoaderRoute: typeof appDashboardGatewayCredentialsRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/bulk-docs/review-queue': {
      id: '/(app)/dashboard/bulk-docs/review-queue'
      path: '/review-queue'
      fullPath: '/dashboard/bulk-docs/review-queue'
      preLoaderRoute: typeof appDashboardBulkDocsReviewQueueRouteImport
      parentRoute: typeof appDashboardBulkDocsRoute
    }
    '/(app)/dashboard/audit-response/$caseId': {
      id: '/(app)/dashboard/audit-response/$caseId'
      path: '/$caseId'
      fullPath: '/dashboard/audit-response/$caseId'
      preLoaderRoute: typeof appDashboardAuditResponseCaseIdRouteImport
      parentRoute: typeof appDashboardAuditResponseRoute
    }
    '/(app)/dashboard/advisor/clients': {
      id: '/(app)/dashboard/advisor/clients'
      path: '/advisor/clients'
      fullPath: '/dashboard/advisor/clients'
      preLoaderRoute: typeof appDashboardAdvisorClientsRouteImport
      parentRoute: typeof appDashboardRoute
    }
  }
}

interface appDashboardAuditResponseRouteChildren {
  appDashboardAuditResponseCaseIdRoute: typeof appDashboardAuditResponseCaseIdRoute
  appDashboardAuditResponseIndexRoute: typeof appDashboardAuditResponseIndexRoute
}

const appDashboardAuditResponseRouteChildren: appDashboardAuditResponseRouteChildren =
  {
    appDashboardAuditResponseCaseIdRoute: appDashboardAuditResponseCaseIdRoute,
    appDashboardAuditResponseIndexRoute: appDashboardAuditResponseIndexRoute,
  }

const appDashboardAuditResponseRouteWithChildren =
  appDashboardAuditResponseRoute._addFileChildren(
    appDashboardAuditResponseRouteChildren,
  )

interface appDashboardBulkDocsRouteChildren {
  appDashboardBulkDocsReviewQueueRoute: typeof appDashboardBulkDocsReviewQueueRoute
}

const appDashboardBulkDocsRouteChildren: appDashboardBulkDocsRouteChildren = {
  appDashboardBulkDocsReviewQueueRoute: appDashboardBulkDocsReviewQueueRoute,
}

const appDashboardBulkDocsRouteWithChildren =
  appDashboardBulkDocsRoute._addFileChildren(appDashboardBulkDocsRouteChildren)

interface appDashboardInvoiceGateRouteChildren {
  appDashboardInvoiceGateAssessmentIdRoute: typeof appDashboardInvoiceGateAssessmentIdRoute
  appDashboardInvoiceGateBatchRoute: typeof appDashboardInvoiceGateBatchRoute
  appDashboardInvoiceGateNewRoute: typeof appDashboardInvoiceGateNewRoute
  appDashboardInvoiceGateReviewRoute: typeof appDashboardInvoiceGateReviewRoute
  appDashboardInvoiceGateIndexRoute: typeof appDashboardInvoiceGateIndexRoute
}

const appDashboardInvoiceGateRouteChildren: appDashboardInvoiceGateRouteChildren =
  {
    appDashboardInvoiceGateAssessmentIdRoute:
      appDashboardInvoiceGateAssessmentIdRoute,
    appDashboardInvoiceGateBatchRoute: appDashboardInvoiceGateBatchRoute,
    appDashboardInvoiceGateNewRoute: appDashboardInvoiceGateNewRoute,
    appDashboardInvoiceGateReviewRoute: appDashboardInvoiceGateReviewRoute,
    appDashboardInvoiceGateIndexRoute: appDashboardInvoiceGateIndexRoute,
  }

const appDashboardInvoiceGateRouteWithChildren =
  appDashboardInvoiceGateRoute._addFileChildren(
    appDashboardInvoiceGateRouteChildren,
  )

interface appDashboardObligationsRouteChildren {
  appDashboardObligationsTaxTypeRoute: typeof appDashboardObligationsTaxTypeRoute
}

const appDashboardObligationsRouteChildren: appDashboardObligationsRouteChildren =
  {
    appDashboardObligationsTaxTypeRoute: appDashboardObligationsTaxTypeRoute,
  }

const appDashboardObligationsRouteWithChildren =
  appDashboardObligationsRoute._addFileChildren(
    appDashboardObligationsRouteChildren,
  )

interface appDashboardSettingsRouteChildren {
  appDashboardSettingsBillingRoute: typeof appDashboardSettingsBillingRoute
  appDashboardSettingsChangePasswordRoute: typeof appDashboardSettingsChangePasswordRoute
  appDashboardSettingsUserProfileRoute: typeof appDashboardSettingsUserProfileRoute
  appDashboardSettingsIndexRoute: typeof appDashboardSettingsIndexRoute
}

const appDashboardSettingsRouteChildren: appDashboardSettingsRouteChildren = {
  appDashboardSettingsBillingRoute: appDashboardSettingsBillingRoute,
  appDashboardSettingsChangePasswordRoute:
    appDashboardSettingsChangePasswordRoute,
  appDashboardSettingsUserProfileRoute: appDashboardSettingsUserProfileRoute,
  appDashboardSettingsIndexRoute: appDashboardSettingsIndexRoute,
}

const appDashboardSettingsRouteWithChildren =
  appDashboardSettingsRoute._addFileChildren(appDashboardSettingsRouteChildren)

interface appDashboardSuppliersRouteChildren {
  appDashboardSuppliersSupplierIdRoute: typeof appDashboardSuppliersSupplierIdRoute
}

const appDashboardSuppliersRouteChildren: appDashboardSuppliersRouteChildren = {
  appDashboardSuppliersSupplierIdRoute: appDashboardSuppliersSupplierIdRoute,
}

const appDashboardSuppliersRouteWithChildren =
  appDashboardSuppliersRoute._addFileChildren(
    appDashboardSuppliersRouteChildren,
  )

interface appDashboardTenantsRouteChildren {
  appDashboardTenantsTenantPublicIdRoute: typeof appDashboardTenantsTenantPublicIdRoute
  appDashboardTenantsIndexRoute: typeof appDashboardTenantsIndexRoute
}

const appDashboardTenantsRouteChildren: appDashboardTenantsRouteChildren = {
  appDashboardTenantsTenantPublicIdRoute:
    appDashboardTenantsTenantPublicIdRoute,
  appDashboardTenantsIndexRoute: appDashboardTenantsIndexRoute,
}

const appDashboardTenantsRouteWithChildren =
  appDashboardTenantsRoute._addFileChildren(appDashboardTenantsRouteChildren)

interface appDashboardRouteChildren {
  appDashboardAccessGrantsRoute: typeof appDashboardAccessGrantsRoute
  appDashboardAuditReadinessRoute: typeof appDashboardAuditReadinessRoute
  appDashboardAuditResponseRoute: typeof appDashboardAuditResponseRouteWithChildren
  appDashboardAuditRiskRoute: typeof appDashboardAuditRiskRoute
  appDashboardBulkDocsRoute: typeof appDashboardBulkDocsRouteWithChildren
  appDashboardComplianceCalendarRoute: typeof appDashboardComplianceCalendarRoute
  appDashboardComplianceWorkspaceRoute: typeof appDashboardComplianceWorkspaceRoute
  appDashboardCustomsTradeRoute: typeof appDashboardCustomsTradeRoute
  appDashboardDeveloperRoute: typeof appDashboardDeveloperRoute
  appDashboardEtimsActivationRoute: typeof appDashboardEtimsActivationRoute
  appDashboardEvidenceRoute: typeof appDashboardEvidenceRoute
  appDashboardGatewayAuditRoute: typeof appDashboardGatewayAuditRoute
  appDashboardInvoiceGateRoute: typeof appDashboardInvoiceGateRouteWithChildren
  appDashboardInvoiceIntelligenceRoute: typeof appDashboardInvoiceIntelligenceRoute
  appDashboardInvoiceQueueRoute: typeof appDashboardInvoiceQueueRoute
  appDashboardInvoiceRepositoryRoute: typeof appDashboardInvoiceRepositoryRoute
  appDashboardMonitoringRoute: typeof appDashboardMonitoringRoute
  appDashboardObligationsRoute: typeof appDashboardObligationsRouteWithChildren
  appDashboardOnboardingRecordsRoute: typeof appDashboardOnboardingRecordsRoute
  appDashboardOnboardingStatusRoute: typeof appDashboardOnboardingStatusRoute
  appDashboardOutboxRoute: typeof appDashboardOutboxRoute
  appDashboardPlatformRoute: typeof appDashboardPlatformRoute
  appDashboardProductsRoute: typeof appDashboardProductsRoute
  appDashboardSettingsRoute: typeof appDashboardSettingsRouteWithChildren
  appDashboardStatusRoute: typeof appDashboardStatusRoute
  appDashboardSuppliersRoute: typeof appDashboardSuppliersRouteWithChildren
  appDashboardTaxReadinessRoute: typeof appDashboardTaxReadinessRoute
  appDashboardTaxpulseRoute: typeof appDashboardTaxpulseRoute
  appDashboardTeamRoute: typeof appDashboardTeamRoute
  appDashboardTenantsRoute: typeof appDashboardTenantsRouteWithChildren
  appDashboardVerificationsRoute: typeof appDashboardVerificationsRoute
  appDashboardIndexRoute: typeof appDashboardIndexRoute
  appDashboardAdvisorClientsRoute: typeof appDashboardAdvisorClientsRoute
  appDashboardGatewayCredentialsRoute: typeof appDashboardGatewayCredentialsRoute
  appDashboardGatewayEndpointsRoute: typeof appDashboardGatewayEndpointsRoute
  appDashboardInvoiceExceptionDocumentIdRoute: typeof appDashboardInvoiceExceptionDocumentIdRoute
}

const appDashboardRouteChildren: appDashboardRouteChildren = {
  appDashboardAccessGrantsRoute: appDashboardAccessGrantsRoute,
  appDashboardAuditReadinessRoute: appDashboardAuditReadinessRoute,
  appDashboardAuditResponseRoute: appDashboardAuditResponseRouteWithChildren,
  appDashboardAuditRiskRoute: appDashboardAuditRiskRoute,
  appDashboardBulkDocsRoute: appDashboardBulkDocsRouteWithChildren,
  appDashboardComplianceCalendarRoute: appDashboardComplianceCalendarRoute,
  appDashboardComplianceWorkspaceRoute: appDashboardComplianceWorkspaceRoute,
  appDashboardCustomsTradeRoute: appDashboardCustomsTradeRoute,
  appDashboardDeveloperRoute: appDashboardDeveloperRoute,
  appDashboardEtimsActivationRoute: appDashboardEtimsActivationRoute,
  appDashboardEvidenceRoute: appDashboardEvidenceRoute,
  appDashboardGatewayAuditRoute: appDashboardGatewayAuditRoute,
  appDashboardInvoiceGateRoute: appDashboardInvoiceGateRouteWithChildren,
  appDashboardInvoiceIntelligenceRoute: appDashboardInvoiceIntelligenceRoute,
  appDashboardInvoiceQueueRoute: appDashboardInvoiceQueueRoute,
  appDashboardInvoiceRepositoryRoute: appDashboardInvoiceRepositoryRoute,
  appDashboardMonitoringRoute: appDashboardMonitoringRoute,
  appDashboardObligationsRoute: appDashboardObligationsRouteWithChildren,
  appDashboardOnboardingRecordsRoute: appDashboardOnboardingRecordsRoute,
  appDashboardOnboardingStatusRoute: appDashboardOnboardingStatusRoute,
  appDashboardOutboxRoute: appDashboardOutboxRoute,
  appDashboardPlatformRoute: appDashboardPlatformRoute,
  appDashboardProductsRoute: appDashboardProductsRoute,
  appDashboardSettingsRoute: appDashboardSettingsRouteWithChildren,
  appDashboardStatusRoute: appDashboardStatusRoute,
  appDashboardSuppliersRoute: appDashboardSuppliersRouteWithChildren,
  appDashboardTaxReadinessRoute: appDashboardTaxReadinessRoute,
  appDashboardTaxpulseRoute: appDashboardTaxpulseRoute,
  appDashboardTeamRoute: appDashboardTeamRoute,
  appDashboardTenantsRoute: appDashboardTenantsRouteWithChildren,
  appDashboardVerificationsRoute: appDashboardVerificationsRoute,
  appDashboardIndexRoute: appDashboardIndexRoute,
  appDashboardAdvisorClientsRoute: appDashboardAdvisorClientsRoute,
  appDashboardGatewayCredentialsRoute: appDashboardGatewayCredentialsRoute,
  appDashboardGatewayEndpointsRoute: appDashboardGatewayEndpointsRoute,
  appDashboardInvoiceExceptionDocumentIdRoute:
    appDashboardInvoiceExceptionDocumentIdRoute,
}

const appDashboardRouteWithChildren = appDashboardRoute._addFileChildren(
  appDashboardRouteChildren,
)

interface authSelfServeSignupRouteChildren {
  authSelfServeSignupVerifyRoute: typeof authSelfServeSignupVerifyRoute
}

const authSelfServeSignupRouteChildren: authSelfServeSignupRouteChildren = {
  authSelfServeSignupVerifyRoute: authSelfServeSignupVerifyRoute,
}

const authSelfServeSignupRouteWithChildren =
  authSelfServeSignupRoute._addFileChildren(authSelfServeSignupRouteChildren)

interface publicPublicRouteChildren {
  publicPublicDocsRoute: typeof publicPublicDocsRoute
  publicPublicFeaturesRoute: typeof publicPublicFeaturesRoute
  publicPublicProductsRoute: typeof publicPublicProductsRoute
  publicPublicIndexRoute: typeof publicPublicIndexRoute
  publicPublicSolutionsProductIdRoute: typeof publicPublicSolutionsProductIdRoute
  publicPublicToolsAdvisorRoute: typeof publicPublicToolsAdvisorRoute
  publicPublicToolsCountyPermitsRoute: typeof publicPublicToolsCountyPermitsRoute
  publicPublicToolsDeadlineCalendarRoute: typeof publicPublicToolsDeadlineCalendarRoute
  publicPublicToolsDeductibilityRoute: typeof publicPublicToolsDeductibilityRoute
  publicPublicToolsEtimsChecklistRoute: typeof publicPublicToolsEtimsChecklistRoute
  publicPublicToolsInvoiceOcrRoute: typeof publicPublicToolsInvoiceOcrRoute
  publicPublicToolsPayeRoute: typeof publicPublicToolsPayeRoute
  publicPublicToolsPenaltyEstimatorRoute: typeof publicPublicToolsPenaltyEstimatorRoute
  publicPublicToolsSupplierPreviewRoute: typeof publicPublicToolsSupplierPreviewRoute
  publicPublicToolsVatRoute: typeof publicPublicToolsVatRoute
  publicPublicToolsWhtRoute: typeof publicPublicToolsWhtRoute
}

const publicPublicRouteChildren: publicPublicRouteChildren = {
  publicPublicDocsRoute: publicPublicDocsRoute,
  publicPublicFeaturesRoute: publicPublicFeaturesRoute,
  publicPublicProductsRoute: publicPublicProductsRoute,
  publicPublicIndexRoute: publicPublicIndexRoute,
  publicPublicSolutionsProductIdRoute: publicPublicSolutionsProductIdRoute,
  publicPublicToolsAdvisorRoute: publicPublicToolsAdvisorRoute,
  publicPublicToolsCountyPermitsRoute: publicPublicToolsCountyPermitsRoute,
  publicPublicToolsDeadlineCalendarRoute:
    publicPublicToolsDeadlineCalendarRoute,
  publicPublicToolsDeductibilityRoute: publicPublicToolsDeductibilityRoute,
  publicPublicToolsEtimsChecklistRoute: publicPublicToolsEtimsChecklistRoute,
  publicPublicToolsInvoiceOcrRoute: publicPublicToolsInvoiceOcrRoute,
  publicPublicToolsPayeRoute: publicPublicToolsPayeRoute,
  publicPublicToolsPenaltyEstimatorRoute:
    publicPublicToolsPenaltyEstimatorRoute,
  publicPublicToolsSupplierPreviewRoute: publicPublicToolsSupplierPreviewRoute,
  publicPublicToolsVatRoute: publicPublicToolsVatRoute,
  publicPublicToolsWhtRoute: publicPublicToolsWhtRoute,
}

const publicPublicRouteWithChildren = publicPublicRoute._addFileChildren(
  publicPublicRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  ManagementRoute: ManagementRoute,
  WorkspaceRoute: WorkspaceRoute,
  appDashboardRoute: appDashboardRouteWithChildren,
  appOnboardingRoute: appOnboardingRoute,
  authAcceptInviteRoute: authAcceptInviteRoute,
  authForgotPasswordRoute: authForgotPasswordRoute,
  authLoginRoute: authLoginRoute,
  authRegisterRoute: authRegisterRoute,
  authResetPasswordRoute: authResetPasswordRoute,
  authSelfServeSignupRoute: authSelfServeSignupRouteWithChildren,
  authVerifyEmailRoute: authVerifyEmailRoute,
  publicPublicRoute: publicPublicRouteWithChildren,
  authMagicLinkVerifyRoute: authMagicLinkVerifyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
